module.exports = __webpack_public_path__ + "static/media/W18-0930_AW_Beyond-Meat_Desktop_Hero_2396x1473_en.680bd2ec.jpg";